import * as actionTypes from './actionsTypes';

export const setSelectedEvent = (selectEvent) => {
  return {
    type: actionTypes.SETSELECTEDEVENT,
    data: selectEvent,
  };
};
